import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './aside.css';

class Aside extends Component {
  render() {
    return (
      <aside className="aside">
        <Link className="aside__link" to="/admin">Квизы</Link>
        <Link className="aside__link" to="/admin/answers">Ответы</Link>
      </aside>
    );
  }
}

export default Aside;
